import React from 'react';
import { Check, X } from 'lucide-react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';


const PricingCard = ({ plan, billingCycle, currentPlanId, onUpgrade, loading }) => {
  const Icon = plan?.icon;
  const price = plan?.price?.[billingCycle];
  const isCurrentPlan = currentPlanId === plan?.id;
  const isCustomPrice = typeof price === 'string';

  return (
    <div
      className={`relative bg-white rounded-2xl shadow-lg p-8 transition-all duration-300 hover:shadow-xl ${
        plan?.recommended ? 'ring-2 ring-blue-500 scale-105' : ''
      }`}
    >
      {plan?.badge && (
        <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
          <span className="inline-flex items-center px-4 py-1 rounded-full text-sm font-medium bg-blue-500 text-white shadow-lg">
            {plan?.badge}
          </span>
        </div>
      )}
      <div className="text-center mb-6">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full mb-4">
          <Icon className="w-8 h-8 text-white" />
        </div>
        <h3 className="text-2xl font-bold text-gray-900 mb-2">{plan?.name}</h3>
        <p className="text-gray-600 text-sm">{plan?.description}</p>
      </div>
      <div className="text-center mb-6">
        {isCustomPrice ? (
          <div className="text-4xl font-bold text-gray-900">{price}</div>
        ) : (
          <>
            <div className="flex items-baseline justify-center">
              <span className="text-5xl font-bold text-gray-900">${price}</span>
              <span className="text-gray-600 ml-2">/{billingCycle === 'monthly' ? 'mo' : 'yr'}</span>
            </div>
            {billingCycle === 'annual' && price > 0 && (
              <p className="text-sm text-gray-500 mt-2">${(price / 12)?.toFixed(2)}/month billed annually</p>
            )}
          </>
        )}
      </div>
      <ul className="space-y-3 mb-8">
        {plan?.features?.map((feature, index) => (
          <li key={index} className="flex items-start gap-3">
            {feature?.included ? (
              <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
            ) : (
              <X className="w-5 h-5 text-gray-300 flex-shrink-0 mt-0.5" />
            )}
            <span className={`text-sm ${feature?.included ? 'text-gray-700' : 'text-gray-400'}`}>
              {feature?.text}
            </span>
          </li>
        ))}
      </ul>
      <Button
        onClick={() => onUpgrade(plan?.id)}
        disabled={isCurrentPlan || loading}
        className={`w-full py-3 rounded-lg font-semibold transition-all duration-200 ${
          plan?.recommended
            ? 'bg-blue-600 hover:bg-blue-700 text-white' :'bg-gray-100 hover:bg-gray-200 text-gray-900'
        } ${isCurrentPlan ? 'opacity-50 cursor-not-allowed' : ''}`}
      >
        {loading ? 'Processing...' : isCurrentPlan ? 'Current Plan' : plan?.cta}
      </Button>
      {isCurrentPlan && (
        <div className="mt-3 text-center">
          <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
            Active
          </span>
        </div>
      )}
    </div>
  );
};

export default PricingCard;